import {observer} from 'mobx-react-lite'
import React, {useRef, useState} from 'react'
import {LinkButtonNew} from '@components/common/base/buttons'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {CreatedAtDropdown} from '@components/statistics/crm-analytics/created-at-dropdown'
import {cn} from '../../../containers/html-utils'
import {CrmAnalyticsStore} from './crm-analytics-store'

export const CreatedAtStickerDropdown = observer(
  ({
    crmAnalyticsStore,
    className
  }: {
    crmAnalyticsStore: CrmAnalyticsStore
    className?: string
  }) => {
    const ref = useRef<HTMLElement>(null)
    const [visible, setVisible] = useState(false)
    return (
      <div>
        <div
          className={cn(
            'flex items-center rounded-8 bg-background-sticker-panel w-fit',
            className
          )}
        >
          <LinkButtonNew
            ref={ref}
            className={`h-24 px-4 rounded-8 bg-primary mx-8 my-4 text-secondary hover:text-secondary active:text-secondary
             ${
               crmAnalyticsStore.dateFilter?.length === 2
                 ? 'outline outline-2 outline-action-default -outline-offset-2'
                 : ''
             } `}
            icon="IconCalendar"
            iconAfter={
              visible ? 'IconCustomChevronUp' : 'IconCustomChevronDown'
            }
            title={crmAnalyticsStore.getDateFilterTitle()}
            onClick={() => setVisible(x => !x)}
            forcedState={visible ? 'active' : undefined}
          />
          <Dropdown
            reference={ref}
            visible={visible}
            onVisibleChange={setVisible}
            content={
              <CreatedAtDropdown crmAnalyticsStore={crmAnalyticsStore} />
            }
            offset={[0, 4]}
            placement="bottom-start"
            theme="new-menu"
            hideArrow
            className="z-50"
          />
        </div>
      </div>
    )
  }
)
